<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();
</script>

<button
  type="button"
  on:click={() => dispatch('click')}
  class="w-20 h-10 bg-black bg-opacity-30 text-center rounded-[50px] flex items-center justify-center"
>
  <span class="text-xs text-white font-bold">再収録</span>
</button>
